<!-- //todo Angular template inheritance is not by default -->
<!-- https://stackoverflow.com/questions/62845665/angular-template-inheritance -->
<div #baseNotifierAppendTo class="append-container"></div>
